.tabsContainer {
  --tab-border-color: transparent !important;
  user-select: none;
}

.tabsTab {
  border: 0;
  font-weight: 300;
  padding: 0.625em;
}

.tabsTab[data-active] {
  font-weight: 500;
}

.indexListItem {
  color: inherit;
  font-size: 0.5em;
}

.chartPerformance {
  color: var(--mantine-color-primary-8);
}